import { withChartLayout } from 'components/common';
import NutritionScreen from 'components/features/chart/admission-history/nutrition-screen/NutritionScreen';

const NutritionScreenPage = withChartLayout('Nutrition Screen')(NutritionScreen);
export default NutritionScreenPage;
